const extractColorChannels = (color: string) => {
    let r: number, g: number, b: number

    const rgbaMatch = color.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
    if (rgbaMatch) {
        r = parseInt(rgbaMatch[1])
        g = parseInt(rgbaMatch[2])
        b = parseInt(rgbaMatch[3])
    } else {
        const c = color.replace('#', '')
        r = parseInt(c.substring(0, 2), 16)
        g = parseInt(c.substring(2, 4), 16)
        b = parseInt(c.substring(4, 6), 16)
    }

    return { r, g, b }
}

const getLuminance = (r: number, g: number, b: number): number => (0.299 * r + 0.587 * g + 0.114 * b) / 255

export const getContrastColor = (color: string): string => {
    const { r, g, b } = extractColorChannels(color)

    return getLuminance(r, g, b) > 0.5 ? '#000000' : '#ffffff'
}

export const getHoverColor = (color: string, intensity = 0.1): string => {
    let { r, g, b } = extractColorChannels(color)

    if (getLuminance(r, g, b) >= 0.5) {
        r = Math.round(r * (1 - intensity * 0.5))
        g = Math.round(g * (1 - intensity * 0.5))
        b = Math.round(b * (1 - intensity * 0.5))
    } else {
        r = Math.min(255, Math.round(r + (255 - r) * intensity))
        g = Math.min(255, Math.round(g + (255 - g) * intensity))
        b = Math.min(255, Math.round(b + (255 - b) * intensity))
    }

    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
}
